/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_Pending_Amendment_TitleInputs */

const en_orders_cancel_pending_amendment_title = /** @type {(inputs: Orders_Cancel_Pending_Amendment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Pending Amendment`)
};

const es_orders_cancel_pending_amendment_title = /** @type {(inputs: Orders_Cancel_Pending_Amendment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar enmienda pendiente`)
};

/**
* | output |
* | --- |
* | "Cancel Pending Amendment" |
*
* @param {Orders_Cancel_Pending_Amendment_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_pending_amendment_title = /** @type {((inputs?: Orders_Cancel_Pending_Amendment_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Pending_Amendment_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_pending_amendment_title(inputs)
	return es_orders_cancel_pending_amendment_title(inputs)
});